import { FC } from "react";
import * as React from "react";

const Button= ({ title, onClick, htmlType='button', disabled=false }) => {
  return (
    <button type={htmlType} onClick={onClick} disabled={disabled} className={`button__auth`}>
      {title}
    </button>
  );
};

export default Button;
